/**
 * Último número marcado manualmente (Llamadas), persistido en localStorage.
 * Misma clave en marcador flotante y página Marcador para comportamiento tipo “rediscar”.
 */
export const CALL_CENTER_LAST_DIALED_STORAGE_KEY = 'sf-floating-dialer-last-number';

export function getLastDialedNumber(): string {
  if (typeof window === 'undefined') return '';
  try {
    return localStorage.getItem(CALL_CENTER_LAST_DIALED_STORAGE_KEY)?.trim() ?? '';
  } catch {
    return '';
  }
}

export function setLastDialedNumber(displayValue: string): void {
  const t = displayValue.trim();
  if (!t) return;
  try {
    localStorage.setItem(CALL_CENTER_LAST_DIALED_STORAGE_KEY, t);
  } catch {
    /* noop */
  }
}
